import React from "react";
import AppRoutes from "./AppRoutes";
import "./App.css";

export default function App() {
  return <AppRoutes />;
}
